import * as React from 'react'
import * as classNames from 'classnames'

import { LabelArrow } from '~/atoms/label/LabelArrow'
import * as Style from './style.css'

type IPageType =
  | typeof PAGE_TYPE_PROFILE_TOP
  | typeof PAGE_TYPE_PROFILE_EDIT_BASE
  | typeof PAGE_TYPE_PROFILE_EDIT_CHILD
  | typeof PAGE_TYPE_PROFILE_EDIT_CONTACT
  | typeof PAGE_TYPE_PROFILE_EDIT_TEXT
  | typeof PAGE_TYPE_PROFILE_EDIT_CREDENTIAL
  | typeof PAGE_TYPE_PROFILE_EDIT_WELFARE
  | typeof PAGE_TYPE_PROFILE_EDIT_CORP_APPLY

export interface IProps {
  pageType?: IPageType
}

export const PAGE_TYPE_PROFILE_TOP = 'TOP'
export const PAGE_TYPE_PROFILE_EDIT_BASE = 'BASE'
export const PAGE_TYPE_PROFILE_EDIT_CHILD = 'CHILD'
export const PAGE_TYPE_PROFILE_EDIT_CONTACT = 'CONTACT'
export const PAGE_TYPE_PROFILE_EDIT_TEXT = 'TEXT'
export const PAGE_TYPE_PROFILE_EDIT_CREDENTIAL = 'CREDENTIAL'
export const PAGE_TYPE_PROFILE_EDIT_WELFARE = 'WELFARE'
export const PAGE_TYPE_PROFILE_EDIT_CORP_APPLY = 'CORP_APPLY'

const makeSideMenus = (pageType?: IPageType) => {
  return [
    {
      label: 'プロフィールTOP',
      href: '/users/base',
      active: pageType === PAGE_TYPE_PROFILE_TOP,
    },
    {
      label: '基本情報',
      href: '/users/profile_edit_base',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_BASE,
    },
    {
      label: 'お子様情報',
      href: '/users/profile_edit_child',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_CHILD,
    },
    {
      label: '連絡先',
      href: '/users/profile_edit_contact',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_CONTACT,
    },
    {
      label: '自己紹介',
      href: '/users/profile_edit_text',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_TEXT,
    },
    {
      label: 'お写真',
      href: '/users/profile_edit_credential',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_CREDENTIAL,
    },
    {
      label: '福利厚生',
      href: '/users/profile_edit_welfare',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_WELFARE,
    },
    {
      label: '法人特典',
      href: '/users/profile_edit_corp_apply',
      active: pageType === PAGE_TYPE_PROFILE_EDIT_CORP_APPLY,
    },
  ]
}

export const ParentSideMenu = ({ pageType }: IProps): JSX.Element => {
  const menus = makeSideMenus(pageType)

  return (
    <ul className={Style.ParentSideMenu}>
      {menus.map((menu) => (
        <li className={Style.ParentSideMenuItem} key={`sidemenu-${menu.label}`}>
          <a className={Style.ParentSideMenuItemLabel} href={menu.href}>
            <LabelArrow color={menu.active ? 'active' : undefined}>
              {menu.label}
            </LabelArrow>
          </a>
        </li>
      ))}
    </ul>
  )
}
